import { IconFolderOutlined } from 'src/assets/icons/IconFolderOutlined';
import { IconHome } from 'src/assets/icons/IconHome';
import { IconList } from 'src/assets/icons/IconList';
import { formatProjectsFolderRoute } from 'src/lib/routing';
import { ROUTES } from 'src/routes';

import { ITEM_TYPE } from './const';

export const createDashboardSidebarItem = () => ({
  type: ITEM_TYPE.link,
  id: 'home',
  label: 'Get started',
  path: ROUTES.DASHBOARD,
  icon: IconList,
  options: {
    whiteIcon: true,
  },
});

export const createRootProjectFolderSidebarItem = () => ({
  type: ITEM_TYPE.link,
  id: 'root_project_folder',
  label: 'Home',
  path: formatProjectsFolderRoute(),
  icon: IconHome,
  options: {
    whiteIcon: true,
  },
});

export const createProjectFolderSidebarItem = (folder) => ({
  type: ITEM_TYPE.link,
  id: folder.id,
  label: folder.name,
  path: formatProjectsFolderRoute(folder.id),
  icon: IconFolderOutlined,
  options: {
    whiteIcon: true,
  },
});
